import BaseNameField from 'registration/js/base/fields/name';

import template from 'registration/templates/dark/fields/name.html';

const NameField = BaseNameField.extend({
    template
});

export default NameField;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/dark/fields/name.js